import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  downloadLinkWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: 16,
    marginBottom: 8,
    background: 'rgba(245, 244, 246, 0.60)',
  },
  dropzone: {
    backgroundColor: '#FFFFFF',
    border: '2px dashed rgb(179, 177, 177)',
    borderRadius: '5px',
    padding: '40px',
  },

  highlightedText: {
    color: '#2fb6f9',
    cursor: 'pointer',
  },
}));

export default useStyles;
